import { render, staticRenderFns } from "./InfoAndSettings.vue?vue&type=template&id=ef17ac06&"
import script from "./InfoAndSettings.vue?vue&type=script&lang=js&"
export * from "./InfoAndSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports